// Copyright Abridged, Inc. 2023,2024. All Rights Reserved.
// Node module: @collabland/sdk
// This file is licensed under the MIT License.
// License text available at https://opensource.org/license/mit/

import {model, property} from '@loopback/repository';

/**
 * The model class is generated from OpenAPI schema - APIUser
 * APIUser
 */
@model({name: 'APIUser'})
export class ApiUser {
  constructor(data?: Partial<ApiUser>) {
    if (data != null && typeof data === 'object') {
      Object.assign(this, data);
    }
  }

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  id?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  username?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  discriminator?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  avatar?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  bot?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  system?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  mfa_enabled?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  banner?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'number',
    },
  })
  accent_color?: number;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  locale?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'boolean',
    },
  })
  verified?: boolean;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
    },
  })
  email?: string;

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      enum: [
        'Staff',
        'Partner',
        'Hypesquad',
        'BugHunterLevel1',
        'MFASMS',
        'PremiumPromoDismissed',
        'HypeSquadOnlineHouse1',
        'HypeSquadOnlineHouse2',
        'HypeSquadOnlineHouse3',
        'PremiumEarlySupporter',
        'TeamPseudoUser',
        'HasUnreadUrgentMessages',
        'BugHunterLevel2',
        'VerifiedBot',
        'VerifiedDeveloper',
        'CertifiedModerator',
        'BotHTTPInteractions',
        'Spammer',
        'DisablePremium',
        'ActiveDeveloper',
        1,
        2,
        4,
        8,
        16,
        32,
        64,
        128,
        256,
        512,
        1024,
        8192,
        16384,
        65536,
        131072,
        262144,
        524288,
        1048576,
        2097152,
        4194304,
        17592186044416,
        'Quarantined',
        1125899906842624,
        'Collaborator',
        2251799813685248,
        'RestrictedCollaborator',
      ],
    },
  })
  flags?:
    | 'Staff'
    | 'Partner'
    | 'Hypesquad'
    | 'BugHunterLevel1'
    | 'MFASMS'
    | 'PremiumPromoDismissed'
    | 'HypeSquadOnlineHouse1'
    | 'HypeSquadOnlineHouse2'
    | 'HypeSquadOnlineHouse3'
    | 'PremiumEarlySupporter'
    | 'TeamPseudoUser'
    | 'HasUnreadUrgentMessages'
    | 'BugHunterLevel2'
    | 'VerifiedBot'
    | 'VerifiedDeveloper'
    | 'CertifiedModerator'
    | 'BotHTTPInteractions'
    | 'Spammer'
    | 'DisablePremium'
    | 'ActiveDeveloper'
    | 1
    | 2
    | 4
    | 8
    | 16
    | 32
    | 64
    | 128
    | 256
    | 512
    | 1024
    | 8192
    | 16384
    | 65536
    | 131072
    | 262144
    | 524288
    | 1048576
    | 2097152
    | 4194304
    | 17592186044416
    | 'Quarantined'
    | 1125899906842624
    | 'Collaborator'
    | 2251799813685248
    | 'RestrictedCollaborator';

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      enum: [
        {
          '0': 'None',
          '1': 'NitroClassic',
          '2': 'Nitro',
          '3': 'NitroBasic',
          None: 0,
          NitroClassic: 1,
          Nitro: 2,
          NitroBasic: 3,
        },
      ],
    },
  })
  premium_type?: {
    '0': 'None';
    '1': 'NitroClassic';
    '2': 'Nitro';
    '3': 'NitroBasic';
    None: 0;
    NitroClassic: 1;
    Nitro: 2;
    NitroBasic: 3;
  };

  /**
   *
   */
  @property({
    jsonSchema: {
      type: 'string',
      enum: [
        {
          '1': 'Staff',
          '2': 'Partner',
          '4': 'Hypesquad',
          '8': 'BugHunterLevel1',
          '16': 'MFASMS',
          '32': 'PremiumPromoDismissed',
          '64': 'HypeSquadOnlineHouse1',
          '128': 'HypeSquadOnlineHouse2',
          '256': 'HypeSquadOnlineHouse3',
          '512': 'PremiumEarlySupporter',
          '1024': 'TeamPseudoUser',
          '8192': 'HasUnreadUrgentMessages',
          '16384': 'BugHunterLevel2',
          '65536': 'VerifiedBot',
          '131072': 'VerifiedDeveloper',
          '262144': 'CertifiedModerator',
          '524288': 'BotHTTPInteractions',
          '1048576': 'Spammer',
          '2097152': 'DisablePremium',
          '4194304': 'ActiveDeveloper',
          Staff: 1,
          Partner: 2,
          Hypesquad: 4,
          BugHunterLevel1: 8,
          MFASMS: 16,
          PremiumPromoDismissed: 32,
          HypeSquadOnlineHouse1: 64,
          HypeSquadOnlineHouse2: 128,
          HypeSquadOnlineHouse3: 256,
          PremiumEarlySupporter: 512,
          TeamPseudoUser: 1024,
          HasUnreadUrgentMessages: 8192,
          BugHunterLevel2: 16384,
          VerifiedBot: 65536,
          VerifiedDeveloper: 131072,
          CertifiedModerator: 262144,
          BotHTTPInteractions: 524288,
          Spammer: 1048576,
          DisablePremium: 2097152,
          ActiveDeveloper: 4194304,
          Quarantined: 17592186044416,
          '17592186044416': 'Quarantined',
          Collaborator: 1125899906842624,
          '1125899906842624': 'Collaborator',
          RestrictedCollaborator: 2251799813685248,
          '2251799813685248': 'RestrictedCollaborator',
        },
      ],
    },
  })
  public_flags?: {
    '1': 'Staff';
    '2': 'Partner';
    '4': 'Hypesquad';
    '8': 'BugHunterLevel1';
    '16': 'MFASMS';
    '32': 'PremiumPromoDismissed';
    '64': 'HypeSquadOnlineHouse1';
    '128': 'HypeSquadOnlineHouse2';
    '256': 'HypeSquadOnlineHouse3';
    '512': 'PremiumEarlySupporter';
    '1024': 'TeamPseudoUser';
    '8192': 'HasUnreadUrgentMessages';
    '16384': 'BugHunterLevel2';
    '65536': 'VerifiedBot';
    '131072': 'VerifiedDeveloper';
    '262144': 'CertifiedModerator';
    '524288': 'BotHTTPInteractions';
    '1048576': 'Spammer';
    '2097152': 'DisablePremium';
    '4194304': 'ActiveDeveloper';
    Staff: 1;
    Partner: 2;
    Hypesquad: 4;
    BugHunterLevel1: 8;
    MFASMS: 16;
    PremiumPromoDismissed: 32;
    HypeSquadOnlineHouse1: 64;
    HypeSquadOnlineHouse2: 128;
    HypeSquadOnlineHouse3: 256;
    PremiumEarlySupporter: 512;
    TeamPseudoUser: 1024;
    HasUnreadUrgentMessages: 8192;
    BugHunterLevel2: 16384;
    VerifiedBot: 65536;
    VerifiedDeveloper: 131072;
    CertifiedModerator: 262144;
    BotHTTPInteractions: 524288;
    Spammer: 1048576;
    DisablePremium: 2097152;
    ActiveDeveloper: 4194304;
    Quarantined: 17592186044416;
    '17592186044416': 'Quarantined';
    Collaborator: 1125899906842624;
    '1125899906842624': 'Collaborator';
    RestrictedCollaborator: 2251799813685248;
    '2251799813685248': 'RestrictedCollaborator';
  };
}

export interface ApiUserRelations {
  // describe navigational properties here
}

export type ApiUserWithRelations = ApiUser & ApiUserRelations;
